import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-bubble-loader',
    templateUrl: './bubble-loader.component.html',
    styleUrls: ['./bubble-loader.component.scss']
})
export class BubbleLoaderComponent implements OnInit {

    @Input() public show: boolean;
    @Input() public height: number;

    constructor() {
    }

    ngOnInit() {
    }

}
